
export { useAdsContext } from "./Ads.context"